import { toLatestFormat } from "./toLatestFormat.js";
const strictlyDeserializeNodes = (editor, serializedElement, errorMessage) => {
  let deserialized;
  try {
    deserialized = JSON.parse(serializedElement);
  } catch (e) {
    throw new Error(errorMessage || `Editor: deserialization error`);
  }
  return toLatestFormat(editor, deserialized).children;
};
export {
  strictlyDeserializeNodes
};
//# sourceMappingURL=strictlyDeserializeNodes.js.map
